import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { tagHotjarRecording } from '../../helpers/util'
import { useState } from 'react'
import useRequest from '../../hooks/useRequest'
import ContentLayout from '../../components/ContentLayout/ContentLayout'
import CardInfo from '../../components/CardInfo/CardInfo'
import InfoLine from '../../components/CardInfo/components/InfoLine'
import CustomDivider from '../../components/CardInfo/components/CustomDivider'
import useGlobalLoading from '../../hooks/useGlobalLoading'
import CellLocation from '../../components/Table/components/CellLocation'
import useScreen from '../../hooks/useScreen'

const ViewSalesRequestPage = props => {
    const { match } = props
    const [request, setRequest] = useState([])
    const [error, setError] = useState('')
    const { handleGetRequestInfo } = useRequest()
    const { changeLoading } = useGlobalLoading()
    const { isMobile } = useScreen()
    const history = useHistory()

    const onGetRequestInfoSuccess = response => {
        let requestInfo = response?.data?.request
        changeLoading(false)
        setRequest(requestInfo)
    }

    const onGetRequestInfoError = res => {
        tagHotjarRecording('API Error')
        let message = res?.response?.data?.message
        changeLoading(false)
        setError(message)
        console.log(error)
    }

    useEffect(() => {
        let requestId = match?.params?.requestId
        changeLoading(true)
        handleGetRequestInfo(
            requestId,
            'sales',
            onGetRequestInfoSuccess,
            onGetRequestInfoError,
        )
    }, [])

    const formatDescriptionInfo = key => {
        switch (key) {
            case 'class':
                return 'Class'
            case 'equipmentCategory':
                return 'Equipment Category'
            case 'forkLength':
                return 'Fork Length'
            case 'fuelType':
                return 'Fuel Type'
            case 'maxCapacity':
                return 'Max Capacity'
            case 'minCapacity':
                return 'Min Capacity'
            case 'tireGroup':
                return 'Tire Group'
            case 'equipment#':
                return 'Equipment Number'
            case 'model#':
                return 'Model'
            case 'sN':
                return 'Serial Number'
            case 'tradeInRequested':
                return 'Trade In'
            default:
                return null
        }
    }

    const renderAssetDetailsInformation = () => {
        const requestDetailsOfInfo = request?.descritpionInfo || {}
        const keysOfDetails = Object.keys(requestDetailsOfInfo) || []
        return (
            <div className="w-full h-auto flex flex-col items-start justify-start lg:py-2">
                {keysOfDetails?.map((item, index) => {
                    return (
                        item != 'equipmentType' &&
                        item != 'equipmentSubtype' && (
                            <>
                                <InfoLine
                                    label={formatDescriptionInfo(item)}
                                    value={
                                        typeof requestDetailsOfInfo[item] ===
                                        'boolean'
                                            ? requestDetailsOfInfo[item] ===
                                              true
                                                ? 'Yes '
                                                : 'No'
                                            : requestDetailsOfInfo[item] || '-'
                                    }
                                />
                                {index + 1 !== keysOfDetails?.length && (
                                    <CustomDivider />
                                )}
                            </>
                        )
                    )
                })}
            </div>
        )
    }

    const renderRequestInformationContent = () => {
        return (
            <div className="w-full h-auto flex flex-col items-start justify-start lg:py-2">
                <InfoLine
                    label="Type of Request"
                    value={request?.typeDisplay || '-'}
                />
                <CustomDivider />
                <InfoLine
                    label="Submitted by"
                    value={request?.contactName || '-'}
                />
                <CustomDivider />
                <InfoLine
                    label="Submitted on"
                    value={request?.formattedDate || '-'}
                    isLast
                />
                <CustomDivider />
                <InfoLine
                    label="Location"
                    value={
                        (
                            <CellLocation
                                isInCard
                                key="assetLocation"
                                address={request?.address || '-'}
                                label={request?.locationName || '-'}
                            />
                        ) || '-'
                    }
                />
            </div>
        )
    }

    const renderHeader = () => {
        return (
            <div className="w-full h-auto flex flex-col items-start justify-start p-4 bg-white border-b border-grayLines lg:gap-4 gap-2">
                <p
                    role="button"
                    onClick={() => {
                        history?.goBack()
                    }}
                    className="text-textDarkGray text-sm font-medium"
                >
                    {'< Go Back'}
                </p>
                <p className="text-black90 font-semibold text-lg">
                    {isMobile
                        ? 'Equipment Quote Request'
                        : `Details of Equipment Quote Request`}
                </p>
            </div>
        )
    }

    return (
        <ContentLayout>
            {renderHeader()}
            <div className="w-full h-auto flex items-start justify-center max-h-full overflow-auto">
                <div className="lg:w-220 w-full h-auto flex flex-col items-center justify-start lg:py-12 lg:p-0 p-4 lg:gap-y-4 gap-y-4">
                    <CardInfo
                        title="Request Information"
                        content={renderRequestInformationContent()}
                    />

                    <CardInfo
                        title="Asset Details"
                        content={renderAssetDetailsInformation()}
                    />
                </div>
            </div>
        </ContentLayout>
    )
}

ViewSalesRequestPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            requestId: PropTypes.string,
        }),
    }),
    location: PropTypes.shape({
        state: PropTypes.shape({
            source: PropTypes.string,
        }),
    }),
}

export default ViewSalesRequestPage
